import isEmpty from 'lodash-es/isEmpty';

import { isValidCellPhone, isValidEmail } from '@ecp/common/src/utils/InputValidateUtils';

import { Custom_Preset } from '@bo-ibSheet/common';

export const MBR_ERR_CODE = {
  MBR_0001: '중복된 아이디가 존재합니다.',
};

export const gridOptions = {
  Cols: [
    { ...Custom_Preset.RowIndex, CanEdit: 0, Visible: 0, CanExport: 0 },
    {
      Header: '회원명',
      Type: 'Text',
      Name: 'memberName',
      Key: 'MBR_NM',
      MinWidth: 150,
      Required: 1,
    },
    {
      Header: '아이디',
      Type: 'Text',
      Name: 'loginId',
      Key: 'LOGIN_ID',
      MinWidth: 150,
      Required: 1,
    },
    {
      Header: '비밀번호',
      Type: 'Text',
      Name: 'password',
      MinWidth: 150,
      CanSort: 0,
      Required: 1,
    },
    {
      Header: '계열사번호',
      Type: 'Text',
      Name: 'subsidiaryCompanyCode',
      Key: 'SBCOM_CD',
      MinWidth: 150,
      Required: 1,
    },
    {
      Header: '회원구분',
      Type: 'Enum',
      Name: 'memberDivisionCode',
      Key: 'MBR_DIVI_CD',
      MinWidth: 150,
      DefaultValue: '20',
      Enum: '|준회원',
      EnumKeys: '|20',
    },
    {
      Header: '이메일주소',
      Type: 'Text',
      Name: 'email',
      Key: 'EMAIL',
      MinWidth: 150,
    },
    {
      Header: '휴대전화번호',
      Type: 'Text',
      Name: 'cellphoneNumber',
      Key: 'CELL_NO',
      MinWidth: 150,
    },
    Custom_Preset.ErrorDescription,
  ],
};

export const memberRegValidators = (subsidiaryCodeList) => ({
  getInitialAccumulator: () => ({}),
  memberName: [
    {
      when: ['created'],
      message: '회원명을 입력해 주세요.',
      validator: ({ memberName }) => !isEmpty(memberName),
    },
  ],
  loginId: [
    {
      when: ['created'],
      message: '아이디를 입력해 주세요.',
      validator: ({ loginId }) => !isEmpty(loginId),
    },
    {
      when: ['created'],
      message: '영문,숫자만 입력해 주세요.',
      validator: ({ loginId }) => {
        const idRegex = /^[a-zA-Z0-9-_.!]+$/;
        return idRegex.test(loginId);
      },
    },
  ],
  subsidiaryCompanyCode: [
    {
      when: ['created'],
      message: '계열사번호를 입력해 주세요.',
      validator: ({ subsidiaryCompanyCode }) => !isEmpty(subsidiaryCompanyCode),
    },
    {
      when: ['created'],
      message: '등록된 계열사번호를 입력해 주세요.',
      validator: ({ subsidiaryCompanyCode }) => subsidiaryCodeList.includes(subsidiaryCompanyCode),
    },
  ],
  password: [
    {
      when: ['created'],
      message: '비밀번호를 입력해 주세요.',
      validator: ({ password }) => !isEmpty(password),
    },
  ],
  email: [
    {
      when: ['created'],
      message: '이메일 양식에 맞게 입력해주세요.',
      validator: ({ email }) => !email || isValidEmail(email),
    },
  ],
  cellphoneNumber: [
    {
      when: ['created'],
      message: '핸드폰 양식에 맞게 입력해주세요.',
      validator: ({ cellphoneNumber }) => !cellphoneNumber || isValidCellPhone(cellphoneNumber),
    },
  ],
  memberDivisionCode: [
    {
      when: ['created'],
      message: '준회원만 입력 가능합니다.',
      validator: ({ memberDivisionCode }) =>
        memberDivisionCode.toString() === '20' || isEmpty(memberDivisionCode.trim()),
    },
  ],
});
